import * as React from 'react';
import { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

export interface IHrProps extends PropsWithChildren {
  layout?: 'default' | 'striped';
}

const Hr: React.FunctionComponent<IHrProps> = (props) => {
  return (
    <hr
      className={classNames([styles['hr']], {
        [styles['layout-default']]: props.layout === 'default' || !props.layout,
        [styles['layout-striped']]: props.layout === 'striped',
      })}
    />
  );
};

Hr.displayName = 'Hr';

export default Hr;
